import i18n from '@/i18n/index';
import { useToasts } from '@/app/util/toasts';

const SUPPORT_EMAIL_ADDRESS = 'support@ziggu.io';

export default function useSupportChat() {
  const { toast_action_failed } = useToasts();

  // index.html always installs a stub window.Intercom that only queues calls, so `booted` is the one
  // sign the chat really started: App.vue skips boot for test tenants, and ad blockers drop the script.
  const openSupportChat = (message) => {
    if (!window.Intercom.booted) {
      toast_action_failed({
        message: i18n.global.t('toast.support_chat.unavailable', { email_address: SUPPORT_EMAIL_ADDRESS }),
        life: 10_000,
      });
      return;
    }
    if (message === undefined) window.Intercom('show');
    else window.Intercom('showNewMessage', message);
  };

  return { openSupportChat };
}
